// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"8babd4c6","425":"03778780","692":"6fb713c5","744":"89c4e9f4","787":"44e5cb87"}[chunkId] + ".chunk.js";
};